import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-medias',
  storeModule.createStoreModule('real-estate-developments-medias')
)
